import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SettingData } from './setting-data';

@Injectable({
  providedIn: 'root'
})
export class SettingService {
  settingData: SettingData;
  settingDataChange: Subject<SettingData> = new Subject<SettingData>();
  constructor() { }

  update(settingData: SettingData) {
    this.settingData = settingData;
    this.settingDataChange.next(this.settingData);
  }

  getYoutubeRestriction(level: number) {
    if (level === 0) {
      return new YoutubeRestrictionData(0, 0);
    }
    if (level === 1) {
      return new YoutubeRestrictionData(5000, 0.65);
    }
    if (level === 2) {
      return new YoutubeRestrictionData(40000, 0.75);
    }
    if (level === 3) {
      return new YoutubeRestrictionData(300000, 0.80);
    }
    if (level === 4) {
      return new YoutubeRestrictionData(900000, 0.85);
    }
  }
}

export class YoutubeRestrictionData {
  viewCountRestriction: number;
  goodRateRestriction: number;
  constructor(viewCountRestriction: number, goodRateRestriction: number) {
    this.viewCountRestriction = viewCountRestriction;
    this.goodRateRestriction = goodRateRestriction;
  }
}
